import { stringify } from 'qs'

import { useCustomSWR } from 'utils/hooks/fetchers'
import { lsGet } from 'utils/request'

export const useArticleLayout = (type, swrOptions) => {
  const { data, ...rest } = useCustomSWR(
    `/articleLayouts?${stringify({ type })}`,
    lsGet,
    swrOptions
  )
  return { data: data?.[0], ...rest }
}
